import { useEffect, useRef, useState } from "react";
import "./NewVendor.css";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import SkuSearchPopUp from "./SkuSearchPopUp";
import moment from "moment";
import {
  Button,
  Card,
  CardBody,
  Col,
  OverlayTrigger,
  Row,
  InputGroup,
  Table,
  Form,
  Tooltip,
} from "react-bootstrap";
import DynamicPagination from "../../components/DynamicPagination ";
import {
  IconPlus,
  IconUserCheck,
  IconUserOff,
  IconTrash,
  IconXboxX,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconBuildingBank,
  IconEye,
  IconEdit,
  IconPaperclip,
  IconMessageCircle,
  IconCreditCard,
  IconSearch,
  IconBox,
  IconLayoutListFilled,
  IconLayoutGridFilled,
  IconFileTypeXls,
  IconFilter,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import { toast } from "react-toastify";
import VendorCard from "./VendorCard";
import quickbookimg from "../../assets/quickbooks.svg";
import View_DetailsVendor from "./ViewDetail/View_DetailsVendor";
import { useSelector } from "react-redux";
import useIdleLogout from "../../hooks/useIdleLogout";
import VendorListUI from "../vendor/VendorListUI";
import axiosInstance from "../../api/axiosInstance";
import Filters from "./FiltersModal/Filters";

const VendorListing = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [isListView, setIsListView] = useState(false);
  const [productLib, setProductLib] = useState({ show: false, autoId: null });

  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const filterBtnRef = useRef(null);
  const [statusFilter, setStatusFilter] = useState("");
  const [createdFrom, setCreatedFrom] = useState(null);
  const [createdTo, setCreatedTo] = useState(null);
  const [globalTotal, setGlobalTotal] = useState(0);

  const navigate = useNavigate();
  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    order: [],
    isStatusUpdate: false,
  });
  const [isCardOpen, setIsCardOpen] = useState({
    show: false,
    auto_id: null,
  });

  const handleCloseCard = () => {
    setIsCardOpen({ show: false, auto_id: null });
    fetchVendors({ page, limit });
  };

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    user: null,
    message: "",
  });

  useIdleLogout();

  const { data: vendors, postData: fetchVendors } = usePostRequest(
    API_ENDPOINTS.GET_VENDORS,
  );

  const { isLoading, postData: updateVendorStatus } = usePostRequest(
    API_ENDPOINTS.VENDOR_STATUS,
  );

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setPage(1);
    setLimit(selectedLimit);
  };

  const handleNewVendor = () => {
    navigate("/create-vendor");
  };

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    fetchVendors({ page, limit });
  };
  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during deactivation.");
  };

  const handleViewClick = (vendor) => {
    setIsViewOpen({
      show: true,
      products: vendor,
      auto_id: vendor.auto_id,
    });

    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${vendor.auto_id}`;
    window.history.pushState(null, "", newUrl);
  };

  const handleActivateVendor = (user) => {
    updateVendorStatus(
      {
        active: true,
        auto_id: user.auto_id,
      },
      onStatusSuccess,
      onStatusError,
    );
    setIsModalOpen({ ...isModalOpen, show: false });
  };

  useEffect(() => {
    fetchVendors({
      page,
      limit,
      search: searchTerm || null,
      active:
        statusFilter === "active"
          ? true
          : statusFilter === "inactive"
            ? false
            : undefined,
      created_date_from: createdFrom
        ? moment(createdFrom).format("YYYY-MM-DD")
        : undefined,
      created_date_to: createdTo
        ? moment(createdTo).format("YYYY-MM-DD")
        : undefined,
    });
  }, [page, limit, isSearchClicked]);

  const getPaginationTotal = (pagination) =>
    pagination?.totalVendors ??
    pagination?.totalRecords ??
    pagination?.totalItems ??
    pagination?.total ??
    0;

  const filteredTotal = getPaginationTotal(vendors?.pagination);

  useEffect(() => {
    if (!statusFilter && !createdFrom && !createdTo) {
      setGlobalTotal(getPaginationTotal(vendors?.pagination));
    }
  }, [vendors]);

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    setPage(1); // Reset to page 1 on new search
    setIsSearchClicked((prev) => !prev);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setStatusFilter("");
    setCreatedFrom(null);
    setCreatedTo(null);
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleFiltersApply = (values) => {
    setStatusFilter(values.status || "");
    setCreatedFrom(values.createdFrom || null);
    setCreatedTo(values.createdTo || null);
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleDeactivateVendor = (user) => {
    if (user.balance > 0) {
      toast.error(
        "This Vendor can't be Inactive because it has a non-zero balance.",
      );
      return;
    }
    updateVendorStatus(
      {
        active: false,
        auto_id: user.auto_id,
      },
      onStatusSuccess,
      onStatusError,
    );

    setIsModalOpen({ ...isModalOpen, show: false });
  };

  const openModal = (action, user) => {
    let modalMessage = "";
    let modalTitle = "";
    let type = "";
    let modalIcon = null;
    let actionHandler = () => { };

    if (action === "delete") {
      type = "danger";
      modalMessage = "Are you sure you want to delete this user?";
      modalTitle = "Delete Vendor";
      modalIcon = <IconTrash />;
      // actionHandler = () => handleDeleteUser(user);
    } else if (action === "activate") {
      type = "warning";
      modalMessage = "Are you sure you want to activate this user?";
      modalTitle = "Activate Vendor";
      modalIcon = <IconUserCheck />;
      actionHandler = () => handleActivateVendor(user);
    } else if (action === "deactivate") {
      type = "warning";
      modalMessage = "Are you sure you want to deactivate this user?";
      modalTitle = "Deactivate Vendor";
      modalIcon = <IconUserOff />;
      actionHandler = () => handleDeactivateVendor(user);
    }

    setIsModalOpen({
      show: true,
      action,
      user,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  // useEffect(() => {
  //   fetchVendors({ page, limit });
  // }, [page, limit]);

  function safeGet(objOrStr, key) {
    try {
      const value =
        typeof objOrStr === "string" ? JSON.parse(objOrStr) : objOrStr;
      return value?.[key] || "N/A";
    } catch {
      return "N/A";
    }
  }

  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");
  const canViewCards = user?.permissions?.manage_cards?.includes("read");



  const handleDownloadExcel = async () => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.VENDOR_EXCEL_DOWNLOAD,
        {
          search: searchTerm || undefined,
          active:
            statusFilter === "active"
              ? true
              : statusFilter === "inactive"
                ? false
                : undefined,
          created_date_from: createdFrom
            ? moment(createdFrom).format("YYYY-MM-DD")
            : undefined,
          created_date_to: createdTo
            ? moment(createdTo).format("YYYY-MM-DD")
            : undefined,
        },
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `vendors_${moment().format("YYYY-MM-DD")}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed:", error);
      toast.error("Excel download failed. Please try again.");
    }
  };

  return (
    <>
      <View_DetailsVendor
        auto_id={isViewOpen.auto_id}
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
      />
      {isCardOpen.show && (
        <VendorCard
          show={isCardOpen.show}
          setShow={handleCloseCard}
          auto_id={isCardOpen.auto_id}
        />
      )}
      {isListView ? null : (
        <>
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">Vendor Management</h2>
              </div>
            </div>
          </div>

          {/* New toolbar layout (mirrors OpportunityListing shared filter bar) — same search/download working as the Card below */}
          {/* <Card className="mb-2 shadow-sm">
            <Card.Body className="p-3">
              <Form
                className="d-flex align-items-center gap-4 position-relative"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              >
                <InputGroup>
                  <Form.Control
                    className="bg-light shadow-none"
                    placeholder="Search anything..."
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                    autoComplete="off"
                  />
                  <InputGroup.Text className="bg-white border-start-0">
                    <IconSearch stroke={2} />
                  </InputGroup.Text>
                </InputGroup>

                <div className="d-flex align-items-center gap-2 border_filter position-relative">
                  <Button
                    ref={filterBtnRef}
                    className="filter-btn"
                    onClick={() => setShowFiltersModal((p) => !p)}
                  >
                    <IconFilter size={16} />
                    <span>Filters</span>
                    {(statusFilter || createdFrom || createdTo) && (
                      <span
                        className="ms-1 badge rounded-pill text-white"
                        style={{
                          backgroundColor: "#fe6338",
                          fontSize: 11,
                          padding: "2px 6px",
                        }}
                      >
                        {
                          [statusFilter, createdFrom || createdTo].filter(
                            Boolean,
                          ).length
                        }
                      </span>
                    )}
                  </Button>

                  <Filters
                    show={showFiltersModal}
                    onHide={() => setShowFiltersModal(false)}
                    anchorRef={filterBtnRef}
                    initialValues={{
                      status: statusFilter,
                      createdFrom,
                      createdTo,
                    }}
                    matchCount={filteredTotal}
                    totalCount={globalTotal}
                    onApply={handleFiltersApply}
                  />
                </div>

                <div className="d-flex align-items-center gap-2 border_filter">
                  <Button variant="warning" onClick={handleSearch}>
                    <IconSearch size={16} /> Search
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={handleClearSearch}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="outline-success"
                    onClick={handleDownloadExcel}
                    className="d-flex align-items-center gap-1"
                  >
                    <IconFileTypeXls size={16} /> Download
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card> */}
          {/* New toolbar layout */}

          <Card className="mb-3">
            <CardBody>
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              >
                <Row className="align-items-end">
                  <Col md={8}>
                    <Form.Label>Search Vendor</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconSearch />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </InputGroup>
                  </Col>
                  <Col md={4}>
                    <div className="d-flex gap-2">
                      <Button
                        className="w-100"
                        variant="warning"
                        onClick={handleSearch}
                      >
                        {" "}
                        Apply Filters{" "}
                      </Button>
                      <Button
                        className="w-100"
                        variant="outline-secondary"
                        onClick={handleClearSearch}
                      >
                        Clear Filters
                      </Button>
                      <Button
                        className="w-100 d-flex align-items-center justify-content-center gap-1"
                        variant="outline-success"
                        onClick={handleDownloadExcel}
                      >
                        <IconFileTypeXls size={16} /> Download
                      </Button>
                    </div>
                  </Col>
                  <Form.Text>
                    Search by company name, vendor name, or any other relevant
                    keyword.
                  </Form.Text>
                </Row>
              </Form>
            </CardBody>
          </Card>
          {/* Old toolbar layout */}
        </>
      )}
      {isListView ? null : (
        <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
          <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
            <IconLayoutGridFilled
              onClick={() => setIsListView(false)}
              style={{
                cursor: "pointer",
                color: !isListView ? "#FE6338" : "#515151",
              }}
            />
            <IconLayoutListFilled
              onClick={() => setIsListView(true)}
              style={{
                cursor: "pointer",
                color: isListView ? "#FE6338" : "#515151",
              }}
            />
          </div>
        </div>
      )}

      {productLib.show && (
        <SkuSearchPopUp
          show={productLib?.show}
          setShow={() => setProductLib({ show: false, autoId: null })}
          autoId={productLib?.autoId}
          vendorName={productLib?.vendorN}
        />
      )}

      {isListView ? (
        <VendorListUI />
      ) : (
        <Row>
          {vendors?.data?.length > 0 ? (
            <>
              {vendors?.data?.map((vendor, index) => (
                <Col md={3} key={index}>
                  <Card
                    className="status_item_card w-100 mb-4"
                    onClick={() => handleViewClick(vendor)}
                    style={{ cursor: "pointer" }}
                  >
                    <Card.Body>

                      {/* <div className="rfq_card_row full_context">
                        <div className="rfq_item_card">
                          <div className="value_card">Vendor Code </div>
                          <p className="label_card">
                            {vendor?.vendor_code || "NA"}
                          </p>
                        </div>

                      </div> */}



                      <div className="rfq_card_row full_context">
                        <div className="rfq_item_card">
                          <div className="value_card">Company Name </div>
                          <p className="label_card">
                            {vendor?.display_name || "NA"}
                          </p>
                        </div>
                        <div className="rfq_item_card">
                          <div className="value_card">Full Name </div>
                          <p className="label_card">
                            {vendor?.first_name || vendor?.last_name
                              ? `${vendor.first_name || ""} ${vendor.last_name || ""
                                }`.trim()
                              : "N/A"}
                          </p>
                        </div>
                      </div>

                      <div className="rfq_card_row">
                        <div className="rfq_item_card">
                          <div className="value_card">Phone Number </div>
                          <p className="label_card">
                            {safeGet(
                              vendor?.VendorContact?.primary_phone,
                              "FreeFormNumber",
                            )}
                          </p>
                        </div>
                        <div className="rfq_item_card">
                          <div className="value_card">Created Date </div>
                          <p className="label_card">
                            {moment(vendor?.createdAt).format("MM/DD/YYYY")}
                          </p>
                        </div>
                      </div>

                      <div className="rfq_card_row">
                        <div className="rfq_item_card">
                          <div className="value_card"> Email Address </div>
                          <p className="label_card">
                            {safeGet(
                              vendor?.VendorContact?.primary_email,
                              "Address",
                            )}
                          </p>
                        </div>
                      </div>

                      <div className="button-groups mb-3">
                        <div className="badge_btn">
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewClick(vendor);
                            }}
                          >
                            <IconEye size={24} />
                          </span>
                          <b>View Details</b>
                        </div>
                        <div className="badge_btn">
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setProductLib({
                                show: true,
                                autoId: vendor?.auto_id,
                                vendorN: vendor?.display_name,
                              });
                            }}
                          >
                            <IconBox size={24} />
                          </span>
                          <b>{vendor?.productCount} products</b>
                        </div>
                        <div className="badge_btn">
                          <span
                            style={{
                              cursor: !canViewCards ? "not-allowed" : "auto",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (canViewCards) {
                                setIsCardOpen({
                                  show: true,
                                  auto_id: vendor.auto_id,
                                });
                              }
                            }}
                          >
                            <IconBuildingBank size={24} />
                          </span>
                          <b> Payment Details </b>
                        </div>
                      </div>

                      <div className="ftr_card_box">
                        <a
                          className="big_badge bg-cyan-lt"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/edit-vendor/${vendor?.auto_id}`);
                          }}
                        >
                          <IconEdit width={18} height={18} /> Edit
                        </a>
                        <div className="rfq_lis_short">
                          <span>
                            <IconCreditCard stroke={1} />{" "}
                            {vendor.detailsCount ?? 0}
                          </span>
                          <span>
                            <IconPaperclip stroke={1} />{" "}
                            {vendor.Attachments?.length ?? 0}
                          </span>
                          <span>
                            <IconMessageCircle stroke={1} />{" "}
                            {vendor.section.reduce((acc, section) => {
                              return acc + section.notes.length;
                            }, 0)}
                          </span>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </>
          ) : (
            <p>No vendors found.</p>
          )}
          {vendors?.data?.length > 0 && (
            <DynamicPagination
              totalPages={vendors?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
              limitOptions={[50, 75, 100, 200]}
            />
          )}

          <ComanConfirmationModal
            show={isModalOpen.show}
            onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
            title={isModalOpen.title}
            message={isModalOpen.message}
            onConfirm={isModalOpen.onConfirm}
            icon={isModalOpen.icon}
            type={isModalOpen.type}
          />
        </Row>
      )}
    </>
  );
};

export default VendorListing;
